
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabbookingintalegaondabha() {



    const cardData =
    {
        keyword: 'Cab Booking in Talegaon Dabhade',
        heading: 'Platinum24 Cabs: Cab Booking in Talegaon Dabhade',
        headingDescription: ' Platinum24 Cabs offers convenient Cab Booking in Talegaon Dabhade, providing safe, comfortable, and affordable travel solutions for residents, professionals, and students in this growing industrial and residential hub. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures smooth rides for local commutes, airport transfers, and outstation journeys. With professional chauffeurs, punctual pickups, and transparent pricing, we make cab travel stress-free and reliable. Whether it’s a corporate transfer, a weekend trip, or daily travel, Platinum24 Cabs guarantees 24/7 availability and dependable cab booking services in Talegaon Dabhade.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


            "services": [
    {
      "name": "Talegaon Dabhade Cab Booking",
      "description": "Easily book your cab in Talegaon Dabhade with our seamless online and phone booking services. Experience quick confirmations and flexible scheduling options, ensuring a hassle-free start to your journey whether it’s for daily travel or special occasions."
    },
    {
      "name": "Taxi Service Talegaon Dabhade",
      "description": "Our Taxi Service in Talegaon Dabhade provides dependable transportation tailored to your needs. With punctual pickups, professional drivers, and well-maintained vehicles, we ensure comfortable and safe rides across the city and beyond."
    },
    {
      "name": "Cab Rental Talegaon Dabhade",
      "description": "Rent cabs in Talegaon Dabhade for short or extended durations with affordable and customizable rental packages. Perfect for family trips, corporate events, or leisure outings, our cab rentals come with experienced drivers for a smooth and stress-free experience."
    },
    {
      "name": "Talegaon Dabhade Local Taxi",
      "description": "Travel within Talegaon Dabhade effortlessly using our Local Taxi service. Ideal for daily commuting, shopping trips, and local errands, enjoy affordable fares, timely service, and courteous drivers ready to assist you 24x7."
    },
    {
      "name": "Affordable Taxi Talegaon Dabhade",
      "description": "Get reliable transportation in Talegaon Dabhade without breaking the bank. Our affordable taxi services provide excellent value with competitive pricing, ensuring you have access to quality rides that fit your budget."
    },
    {
      "name": "Talegaon Dabhade Taxi with Driver",
      "description": "Relax and enjoy your journey with our Taxi service in Talegaon Dabhade that includes professional drivers committed to your safety and comfort. Whether for a quick ride or a long trip, our drivers ensure punctuality and excellent service."
    },
    {
      "name": "Talegaon Dabhade Airport Taxi",
      "description": "Make airport transfers hassle-free with our Talegaon Dabhade Airport Taxi service. Available 24x7, we offer timely pickups and drop-offs to Pune and nearby airports, ensuring you catch your flights without any stress."
    },
    {
      "name": "Cab Service Near Me Talegaon Dabhade",
      "description": "Find trusted cab services near you in Talegaon Dabhade quickly. Our extensive network guarantees prompt taxi availability wherever you are in the city, with professional drivers and clean vehicles at your service."
    },
    {
      "name": "Talegaon Dabhade Outstation Taxi",
      "description": "Plan your outstation trips with ease using our Talegaon Dabhade Outstation Taxi service. Whether it's business or leisure, enjoy comfortable rides with flexible packages, experienced drivers, and competitive pricing."
    },
    {
      "name": "Talegaon Dabhade Corporate Taxi",
      "description": "Our Corporate Taxi service in Talegaon Dabhade caters to businesses needing reliable and timely transportation solutions. Customized packages and professional chauffeurs help streamline your corporate travel needs efficiently."
    },
    {
      "name": "Talegaon Dabhade Taxi Deals",
      "description": "Save more on your rides with our exclusive Talegaon Dabhade Taxi Deals, offering discounts and special packages for local trips, airport transfers, and outstation journeys. Experience premium service at affordable rates."
    },
    {
      "name": "Talegaon Dabhade City Taxi",
      "description": "Explore Talegaon Dabhade city conveniently with our City Taxi service. Whether for sightseeing, meetings, or errands, our taxis provide reliable and comfortable transport at all hours."
    },
    {
      "name": "Talegaon Dabhade Family Taxi",
      "description": "Travel safely and comfortably with your family using our Family Taxi service in Talegaon Dabhade. Spacious vehicles, professional drivers, and personalized service make your family outings and daily travel stress-free."
    },
    {
      "name": "Taxi Booking Online Talegaon Dabhade",
      "description": "Book your Talegaon Dabhade taxi online anytime through our secure, user-friendly platform. Enjoy instant booking confirmations, easy cancellations, and 24x7 customer support for a seamless travel experience."
    },
    {
      "name": "Talegaon Dabhade Taxi Service 24x7",
      "description": "Our 24x7 Taxi Service in Talegaon Dabhade ensures you always have access to safe, reliable transportation whenever you need it. Perfect for emergencies, late-night rides, or early morning trips, we’re always ready to serve you."
    }
  ],
  "tableData": [
    ["Talegaon Dabhade Cab Booking", "Taxi Service Talegaon Dabhade"],
    ["Cab Rental Talegaon Dabhade", "Talegaon Dabhade Local Taxi"],
    ["Affordable Taxi Talegaon Dabhade", "Talegaon Dabhade Taxi with Driver"],
    ["Talegaon Dabhade Airport Taxi", "Cab Service Near Me Talegaon Dabhade"],
    ["Talegaon Dabhade Outstation Taxi", "Talegaon Dabhade Corporate Taxi"],
    ["Talegaon Dabhade Taxi Deals", "Talegaon Dabhade City Taxi"],
    ["Talegaon Dabhade Family Taxi", "Taxi Booking Online Talegaon Dabhade"],
    ["Talegaon Dabhade Taxi Service 24x7", "—"]
  ],


     "whychoose": [
    {
      "WhyChooseheading": "Easy and Reliable Cab Booking in Talegaon Dabhade",
      "WhyChoosedescription": "Platinum24 Cabs offers hassle-free and quick cab booking services in Talegaon Dabhade for all your travel needs."
    },
    {
      "WhyChooseheading": "Prompt Pickup with Drivers Near You",
      "WhyChoosedescription": "Our drivers are strategically positioned around Talegaon Dabhade to ensure fast and timely pickups."
    },
    {
      "WhyChooseheading": "Clean, Comfortable, and Sanitized Vehicles",
      "WhyChoosedescription": "Travel in air-conditioned cabs that are regularly sanitized for your safety and comfort."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
      "WhyChoosedescription": "Our professional drivers know the best routes around Talegaon Dabhade to avoid traffic and ensure a smooth ride."
    },
    {
      "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy transparent fares that include fuel, tolls, and driver allowances for worry-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with bookings and any travel queries."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Local and Outstation Trips",
      "WhyChoosedescription": "Choose from point-to-point rides, hourly rentals, or long-distance journeys as per your travel plans."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your group size and comfort preferences."
    }
  ]
























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab booking services in Talegaon Dabhade?',
        answer: 'Yes, Platinum24 Cabs offers reliable and convenient cab booking services in Talegaon Dabhade for both local and outstation travel.',
    },
    {
        question: 'How can I book a cab in Talegaon Dabhade with Platinum24 Cabs?',
        answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for cab bookings in Talegaon Dabhade?',
        answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars to meet your travel needs.',
    },
    {
        question: 'Can I book cabs for local travel as well as outstation trips from Talegaon Dabhade?',
        answer: 'Yes, we provide both local cab services and outstation trips from Talegaon Dabhade to various destinations.',
    },
    {
        question: 'Are your drivers experienced and familiar with Talegaon Dabhade routes?',
        answer: 'Absolutely, our drivers are professional, licensed, and knowledgeable about Talegaon Dabhade and surrounding areas.',
    },
    {
        question: 'Can I hire a cab on an hourly basis in Talegaon Dabhade?',
        answer: 'Yes, hourly rental packages are available for local travel within Talegaon Dabhade and nearby areas.',
    },
    {
        question: 'Are safety and hygiene protocols followed for cab services in Talegaon Dabhade?',
        answer: 'All vehicles are sanitized regularly, and drivers follow strict safety protocols to ensure passenger well-being.',
    },
    {
        question: 'Is cab service in Talegaon Dabhade available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 cab booking and services in Talegaon Dabhade for your convenience.',
    },
    {
        question: 'What payment options are available for cab bookings in Talegaon Dabhade?',
        answer: 'We accept cash, digital payments, UPI, and card payments for smooth and flexible transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Talegaon Dabhade?',
        answer: 'Yes, you can specify any pickup and drop-off points within Talegaon Dabhade as per your requirements.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sandeep More',
        feedback: 'Booked a cab in Talegaon Dabhade with Platinum24 Cabs. The driver was punctual and the ride was comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Aarti Kulkarni',
        feedback: 'Excellent cab booking experience in Talegaon Dabhade. Easy to book and professional service.',
        rating: 5,
    },
];
































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const talegaonDabhadeTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab booking service in Talegaon Dabhade offering local, airport, outstation, corporate, and family taxi services with professional drivers available 24x7.",
  "areaServed": {
    "@type": "Place",
    "name": "Talegaon Dabhade, Pune"
  },
  "serviceType": [
    "Talegaon Dabhade Cab Booking",
    "Taxi Service Talegaon Dabhade",
    "Cab Rental Talegaon Dabhade",
    "Talegaon Dabhade Local Taxi",
    "Affordable Taxi Talegaon Dabhade",
    "Talegaon Dabhade Taxi with Driver",
    "Talegaon Dabhade Airport Taxi",
    "Cab Service Near Me Talegaon Dabhade",
    "Talegaon Dabhade Outstation Taxi",
    "Talegaon Dabhade Corporate Taxi",
    "Talegaon Dabhade Taxi Deals",
    "Talegaon Dabhade City Taxi",
    "Talegaon Dabhade Family Taxi",
    "Taxi Booking Online Talegaon Dabhade",
    "Talegaon Dabhade Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};







    return (
        <div>
<Helmet>
  <title>Cab Booking in Talegaon Dabhade | Reliable Taxi Service Talegaon Dabhade</title>
  <meta
    name="description"
    content="Reliable and affordable cab booking service in Talegaon Dabhade offering local, airport, outstation, corporate, and family taxi services with professional drivers available 24x7."
  />
  <meta
    name="keywords"
    content="Talegaon Dabhade Cab Booking, Taxi Service Talegaon Dabhade, Cab Rental Talegaon Dabhade, Talegaon Dabhade Local Taxi, Affordable Taxi Talegaon Dabhade, Talegaon Dabhade Taxi with Driver, Talegaon Dabhade Airport Taxi, Cab Service Near Me Talegaon Dabhade, Talegaon Dabhade Outstation Taxi, Talegaon Dabhade Corporate Taxi, Talegaon Dabhade Taxi Deals, Talegaon Dabhade City Taxi, Talegaon Dabhade Family Taxi, Taxi Booking Online Talegaon Dabhade, Talegaon Dabhade Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(talegaonDabhadeTaxiSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/74.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabbookingintalegaondabha;